var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIncludedReleases(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 22",
    enableBackground: "new 0 0 20 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7941E",
    d: "M3,14c0-0.0659,0.0049-0.1367,0.0059-0.2031L1,15c0,0-1,3-1,7c1.4727-1.1035,2.9424-1.7998,4.2148-2.2407 C3.4824,18.4287,3,16.582,3,14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7941E",
    d: "M15.7852,19.7593C17.0576,20.2002,18.5273,20.8965,20,22c0-4-1-7-1-7l-2.0059-1.2031 C16.9951,13.8633,17,13.9341,17,14C17,16.582,16.5176,18.4287,15.7852,19.7593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F15A29",
    d: "M10,18.5c-2.2773,0-3.9531,0.7773-4.3828,1.5962C6.7119,21.4658,8.2676,22,10,22 c1.7314,0,3.2871-0.5342,4.3828-1.9043C13.9521,19.2773,12.2773,18.5,10,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F15A29",
    d: "M10,17.5c2.2305,0,4.0977,0.6948,4.9678,1.7129C15.6191,17.9839,16,16.2861,16,14c0-6.0752-2.6875-14-6-14 C6.6865,0,4,7.9248,4,14c0,2.2861,0.3809,3.9839,1.0322,5.2134C5.9023,18.1948,7.7695,17.5,10,17.5z M10,4c1.1055,0,2,0.8955,2,2 c0,1.1055-0.8945,2-2,2C8.8945,8,8,7.1055,8,6C8,4.8955,8.8945,4,10,4z M10,10c1.1055,0,2,0.8955,2,2c0,1.1055-0.8945,2-2,2 c-1.1055,0-2-0.8945-2-2C8,10.8955,8.8945,10,10,10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncludedReleases);
export default __webpack_public_path__ + "static/media/ic_included_releases.8f592a455b222b13dadc3fc3b3edeab5.svg";
export { ForwardRef as ReactComponent };